function hexToLottieColor(hex) {
  const cleaned = (hex || '#667eea').replace('#', '');
  const normalized = cleaned.length === 3
    ? cleaned.split('').map((char) => char + char).join('')
    : cleaned;

  return [
    parseInt(normalized.slice(0, 2), 16) / 255,
    parseInt(normalized.slice(2, 4), 16) / 255,
    parseInt(normalized.slice(4, 6), 16) / 255,
    1,
  ];
}

function applyLottieColor(node, color) {
  if (!node || typeof node !== 'object') return;

  if (Array.isArray(node)) {
    node.forEach((item) => applyLottieColor(item, color));
    return;
  }

  if (
    node.c
    && node.c.a === 0
    && Array.isArray(node.c.k)
    && node.c.k.length === 4
    && typeof node.c.k[0] === 'number'
  ) {
    node.c.k = [...color];
  }

  Object.values(node).forEach((value) => applyLottieColor(value, color));
}

export default function recolorLottieAnimation(animationData, hexColor) {
  const clone = JSON.parse(JSON.stringify(animationData));
  applyLottieColor(clone, hexToLottieColor(hexColor));
  return clone;
}
